import { render } from "./meta-data-form.vue?vue&type=template&id=36e3c39b&scoped=true"
import script from "./meta-data-form.vue?vue&type=script&lang=js"
export * from "./meta-data-form.vue?vue&type=script&lang=js"

import "./meta-data-form.vue?vue&type=style&index=0&id=36e3c39b&scoped=true&lang=css"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e3c39b"]])

export default __exports__